<template>
    <div v-if="loading" class="loading">Loading...</div>
    <div :class="blur ? 'blur-lg' : '' " class="fixed h-screen w-screen bg-[url('../assets/background/store.jpg')] bg-cover bg-center bg-no-repeat">
        <div class="flex h-full">

            <div class="h-full w-1/6">
                <div class="flex flex-col relative p-5 gap-10">
                    <router-link :to="`/checkpoint`">
                        <div class="bg-white rounded-lg shadow-lg shadow-slate-500 w-fit p-2">
                            <img class="w-10" src="../assets/icon/icon-home.png" alt="home">
                        </div>
                    </router-link>
                    <div class="xl:mt-48 lg:mt-48 md:mt-10 sm:mt-10">
                        <img class="w-[600px] absolute" src="../assets/avatar/avatar-flip.png" alt="avatar">
                    </div>
                </div>
            </div>

            <div class="flex flex-col h-screen w-4/6 justify-center items-center">           
                <div class="p-4 w-full flex justify-center items-center bg-slate-100 shadow-xl rounded-lg py-4">
                    <p class="xl:text-6xl lg:text-6xl md:text-4xl sm:text-4xl">คำนวณราคาสินค้า</p>
                    <Sound :checkpoint='5' :autoplay='false'/>
                </div> 
                <div class="flex border-4 justify-around rounded-lg shadow-lg w-full py-4">
                    <div class="flex xl:p-20 lg:p-2 md:p-2 sm:p-1 bg-violet-200 rounded-lg shadow-lg">
                        <div v-for="(item, index) in levels[$store.state.level].data" :key="item.name">
                            <div class="h-full flex items-center justify-center">
                              <div class="h-full w-full flex flex-col justify-center items-center">
                                  <div class="h-2/3 flex justify-center items-center">
                                      <img class="xl:w-40 lg:w-36 md:w-20 sm:w-14" :src="item.url" :alt="item.name">
                                  </div>
                                  <div class="h-1/3">
                                      <p class="xl:text-4xl lg:text-2xl md:text-2xl sm:text-xl h-full p-2 flex items-center font-bold justify-center text-emerald-500 bg-transparent shadow-lg rounded-lg">{{ item.price }} บาท</p>
                                  </div>                                
                              </div>
                              <div v-if="index !== (levels[$store.state.level].data.length - 1)">
                                <div class="text-2xl font-bold">&nbsp;+&nbsp;</div>
                              </div>                              
                            </div>
                        </div>   
                    </div>
                </div> 

                <div class="w-full mt-2 rounded-md shadow-lg drop-shadow-lg">
                    <div class="flex justify-around border-4 rounded-lg p-4">                    
                        <div @click="checkAnswer($store.state.level, levels[$store.state.level].choices.left)" class="transition ease-in-out delay-150 flex py-2 w-full mr-10 mb-2 justify-center border border-gray-700 rounded-lg shadow-lg shadow-orange-500 bg-indigo-500 hover:ring-4 hover:ring-indigo-400 hover:-translate-y-1 hover:scale-110 duration-300 cursor-pointer">
                            <p class="xl:text-6xl lg:text-6xl md:text-4xl sm:text-4xl font-semibold text-white">{{ levels[$store.state.level].choices.left }} บาท</p>
                        </div>
                        <div @click="checkAnswer($store.state.level, levels[$store.state.level].choices.right)" class="transition ease-in-out delay-150 flex py-2 w-full mr-10 mb-2 justify-center border border-gray-700 rounded-lg shadow-lg shadow-orange-500 bg-indigo-500 hover:ring-4 hover:ring-indigo-400 hover:-translate-y-1 hover:scale-110 duration-300 cursor-pointer">
                            <p class="xl:text-6xl lg:text-6xl md:text-4xl sm:text-4xl font-semibold text-white">{{ levels[$store.state.level].choices.right }} บาท</p>
                        </div>                        
                    </div>
                </div>

            </div>
        </div>
        <Answer :checkCorrect="checkCorrect" :star="star" :resetGame="resetGame" :nextCheckPoint="nextCheckPoint" /> 
    </div>
    <HowTo :setShowContent="setShowContent" :checkpoint='5'/>
</template>

<script>
import HowTo from "../components/HowTo.vue";
import Sound from "../components/Sound.vue";
import Answer from "../components/Answer.vue";
import actionUpdateCheckpoint from '../js/firebase-action';
import logPlay from '../js/logs-play';
import soundAnswer from "../js/sound-answer";

const path = '../assets/checkpoint/5';

export default {
    name: "CheckPointCalculate",
    components: {
        HowTo,
        Sound,
        Answer
    },
    data(){
        return {
            blur: true,    
            checkCorrect: '',
            star: 0,             
            countGameOver: 0,           
            levels: {
                easy: {
                    choices: {
                        left: 40,
                        right: 50
                    },
                    answer: 40,
                    data: [
                        {
                            url: `${path}/egg.png`,
                            name: 'egg',
                            check: true,
                            price: 5,
                        },                
                        {
                            url: `${path}/bottom.png`,
                            name: 'bottom',
                            check: true,
                            price: 10,
                        },                    
                        {
                            url: `${path}/meat.png`,
                            name: 'meat',
                            check: true,
                            price: 25,
                        },                    
                    ]
                },
                medium: {
                    choices: {
                        left: 155,
                        right: 165
                    },
                    answer: 155,
                    data: [                   
                        {
                            url: `${path}/egg2.png`,
                            name: 'egg',
                            check: true,
                            price: 10,
                        },                
                        {
                            url: `${path}/bottom2.png`,
                            name: 'bottom',
                            check: true,
                            price: 20,
                        },                    
                        {
                            url: `${path}/meat.png`,
                            name: 'meat',
                            check: true,
                            price: 125,
                        },
                    ]
                },
                hard: {
                    choices: {
                        left: 300,
                        right: 400
                    },
                    answer: 300,
                    data: [
                        {
                            url: `${path}/vegetables.png`,
                            name: 'vegetables',
                            check: true,
                            price: 5,
                        },                
                        {
                            url: `${path}/egg3.png`,
                            name: 'egg',
                            check: true,
                            price: 15,
                        },                    
                        {
                            url: `${path}/bottom3.png`,
                            name: 'bottom3',
                            check: true,
                            price: 30,
                        },
                        {
                            url: `${path}/meat.png`,
                            name: 'meat',
                            check: true,
                            price: 250,
                        },
                    ]
                }
            },            
        };        
    },
    created () {
        !this.$store.state.user_id ? window.location.replace("/#/logout/") : '';          
    },
    methods: {
        setShowContent() {
            this.blur = false;           
        },
        setShowModalCorrect() {
            // this.blur = true;
            this.checkCorrect = 'correct';
        },
        setShowModalInCorrect() {
            // this.blur = true;
            this.checkCorrect = 'incorrect';
        },
        checkGameOver() {            
            console.log('Count Game Over'+ (this.countGameOver + 1));
            this.countGameOver += 1;
            if(this.countGameOver >= 3){                
                this.star = 1;
                this.countGameOver = 0;
                this.updateCheckpointStarInFirebase();
                this.setShowModalInCorrect();
            }else{
                this.resetGame();
            }            
        },
        checkAnswer(level, answer) {

            const correct = this.levels[level].answer;
            
            console.log({
                level: level,
                answer: answer,
            })

            if(correct === answer){
                this.star = this.countGameOver === 2 ? 2 : 3;
                this.countGameOver = 0; 
                this.updateCheckpointStarInFirebase();
                this.setShowModalCorrect();
                soundAnswer('correct');
            }else{
                soundAnswer('incorrect');
                this.checkGameOver();
            }
        },
        resetGame(){
            this.blur = false;
            this.checkCorrect = '';
        },
        nextCheckPoint(){            
            const checkpoints = this.$store.state.checkpoints;
            const level = this.$store.state.level;
            var parseCheckpoint = JSON.parse(JSON.stringify(checkpoints));
            const starByCheckpoint = parseCheckpoint[level];
            const my_checkpoint = 5;
            const checkpoint_index = [1, 2, 3, 4, 5, 6];

            const next = checkpoint_index.filter((i) => {
                const star = starByCheckpoint[`checkpoint_${i}`];
                return i > my_checkpoint && star < 3 ? i : '';                
            });

            window.location.replace(`/#/checkpoint/${next.length > 0 ? next[0]: ''}`);
        },
        async updateCheckpointStarInFirebase() {
            const checkpoints = this.$store.state.checkpoints;
            const level = this.$store.state.level;
            const document_id = this.$store.state.user_id;
            const checkpointUpdate = {
                checkpoint_5: this.star
            }

            const user = this.$store.state.user;
            await logPlay(user, 5, this.star);
            
            var parseCheckpoint = JSON.parse(JSON.stringify(checkpoints));
            const starByCheckpoint = parseCheckpoint[level]['checkpoint_5'];         

            if(this.star > starByCheckpoint){
                parseCheckpoint[level]['checkpoint_5'] = this.star;
                await actionUpdateCheckpoint(document_id, level, checkpoints, checkpointUpdate);
                this.$store.dispatch('setCheckPoint', parseCheckpoint);
            }
        }
    }    
};
</script>